"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProConFocusedLoanCard = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _proConFocusedBody = _interopRequireDefault(require("./pro-con-focused-body"));

var _offerStyles = require("./offer-styles");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["className"];

var ProConFocusedLoanCard = function ProConFocusedLoanCard(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.OfferCardWrapper, {
    className: className,
    "data-testid": "loancard-v3:loan-card-index:wrapper",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_proConFocusedBody["default"], Object.assign({}, rest))
  });
};

exports.ProConFocusedLoanCard = ProConFocusedLoanCard;
ProConFocusedLoanCard.Body = _proConFocusedBody["default"];

var _default = (0, _styledComponents["default"])(ProConFocusedLoanCard).withConfig({
  componentId: "sc-1shkb73-0"
})([""]);

exports["default"] = _default;
//# sourceMappingURL=pro-con-focused-card.js.map